<div class="grid bg-white p-4">
    <div class="col-12">
        <div class="main-title">
            Datos del Proveedor
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Nombre completo:</h4>
        <p>{{provider?.fullName ?? ''}}</p>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">RFC:</h4>
        <p>{{provider?.rfc}}</p>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Sector:</h4>
        <p>{{provider?.sector}}</p>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Subsector:</h4>
        <p>{{provider?.subSector}}</p>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Estatus:</h4>
        <p>{{provider?.status}}</p>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Fecha de creación:</h4>
        <p>{{provider?.createdAt | date: 'dd/MM/yyyy': 'UTC'}}</p>
    </div>
</div>

<ng-container *ngIf="provider">
    <div class="col-12 bg-white p-3">
        <div class="main-title">
            Activos del proveedor
        </div>
        <app-main-table
            [apiService]="apiAssetService" 
            [columns]="assetsColumns"
            [pluralEntityName]="'activos'"
        ></app-main-table>
    </div>
</ng-container>
